import { Currency } from "components/CustomCurrency/currency";

function getTableData(data) {
  // param: data list of: [    {
  //     "empresa": "ALIMENTOS BALANCEADOS AVIFORTE CIA. LTDA.",
  //     "venta1": 26339344.90,
  //     "venta2": 27030684.20,
  //     "venta3": 26711677.80,
  //     "totalsales": 80081706.90,
  //     "sector": "AVICULTURA / GANADERÍA"
  // }]

  var rows = [];
  data.forEach((elem, index) => {
    var _temp = {
      Nro: index + 1,
      company: elem.empresa,
      sector: elem.sector,
      total: <Currency value={elem.totalsales} />,
      2019: <Currency value={elem.venta1} />,
      2020: <Currency value={elem.venta2} />,
      2021: <Currency value={elem.venta3} />,
    };
    rows.push(_temp);
  });

  // return values in a format that charts components understand
  let now = new Date();
  let anio3 = now.getFullYear();
  return {
    columns: [
      { Header: "Nro", accessor: "Nro", width: "5%" },
      { Header: "Empresa", accessor: "company" },
      { Header: "Sector", accessor: "sector" },
      { Header: "Total", accessor: "total", width: "12%" },
      { Header: anio3 - 3, accessor: "2019", width: "12%" },
      { Header: anio3 - 2, accessor: "2020", width: "12%" },
      { Header: anio3 - 1, accessor: "2021", width: "12%" },
    ],
    rows: rows,
  };
}

export default getTableData;
